/**
 * SkipNavLink
 *
 * Accessibility skip-to-content link for keyboard navigation.
 * Visually hidden until focused via Tab key.
 */

interface SkipNavLinkProps {
  targetId?: string
  label?: string
}

export function SkipNavLink({
  targetId = 'main-content',
  label = 'Skip to main content',
}: SkipNavLinkProps) {
  return (
    <a
      href={`#${targetId}`}
      data-figma-ignore
      className="fixed -top-[100px] left-4 z-[9999] bg-primary text-white px-4 py-2 rounded-[var(--radius-button)] font-semibold text-sm transition-[top] duration-150 ease-in focus:top-4 focus:outline-2 focus:outline-primary focus:outline-offset-2"
    >
      {label}
    </a>
  )
}
